module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-support-buttons-item-icon-49ca6c0e926dc7fb30d3af149caefbdb.svg";